var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmailSending(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 18,
    viewBox: "0 0 42 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_623_24978)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_623_24978",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 42,
    height: 18
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42 0.5H0V17.5H42V0.5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_623_24978)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.93
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.7019 5.63965C33.6336 5.63965 35.2019 7.208 35.2019 9.13965C35.2019 11.0713 33.6336 12.6396 31.7019 12.6396C29.7703 12.6396 28.2019 11.0713 28.2019 9.13965C28.2019 7.208 29.7703 5.63965 31.7019 5.63965Z",
    fill: "#648AEB"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.916
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.0779 5.63965C23.0095 5.63965 24.5779 7.208 24.5779 9.13965C24.5779 11.0713 23.0095 12.6396 21.0779 12.6396C19.1462 12.6396 17.5779 11.0713 17.5779 9.13965C17.5779 7.208 19.1462 5.63965 21.0779 5.63965Z",
    fill: "#648AEB"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.636
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0779 5.63965C12.0095 5.63965 13.5779 7.208 13.5779 9.13965C13.5779 11.0713 12.0095 12.6396 10.0779 12.6396C8.14623 12.6396 6.57788 11.0713 6.57788 9.13965C6.57788 7.208 8.14623 5.63965 10.0779 5.63965Z",
    fill: "#648AEB"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_623_24978"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 17,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailSending);
export default __webpack_public_path__ + "static/media/email-sending.1af452e5f87b7ea6b2ffc0107acf4e94.svg";
export { ForwardRef as ReactComponent };